import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { ThemeProvider } from '@pray/shared/contexts';

import { SolomonPanelProvider, SolomonPanel } from 'components/global/SolomonPanel';
import { STUDIO_EVALUATED_FEATURE_FLAG_IDS } from 'constants.js';
import FeatureFlagProvider from 'context/FeatureFlagContext';
import StudioContextProvider from 'context/StudioContext';

import App from './App';

import '@pray/shared/styles/normalize.css';
import '@pray/shared/styles/global.css';

import './styles/app.scss';
import './styles/globals.css';

export const rootSelector = '#root';

const root = ReactDOM.createRoot(document.querySelector(rootSelector)!);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider defaultTheme={{ colorMode: 'light', variant: 'studio' }}>
      <StudioContextProvider>
        <FeatureFlagProvider flagIds={STUDIO_EVALUATED_FEATURE_FLAG_IDS}>
          <SolomonPanelProvider>
            <App />
            <SolomonPanel />
          </SolomonPanelProvider>
        </FeatureFlagProvider>
      </StudioContextProvider>
    </ThemeProvider>
  </QueryClientProvider>
);
// build: 20260404045936
